import { render, staticRenderFns } from "./EmbeddedReport.vue?vue&type=template&id=747c73ea&scoped=true&lang=html&"
import script from "./EmbeddedReport.vue?vue&type=script&lang=js&"
export * from "./EmbeddedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c73ea",
  null
  
)

export default component.exports